//const backendDomin = process.env.REACT_APP_API_URL;

const backendDomin = process.env.REACT_APP_LOCALHOST_URI;

const SummaryApi = {
    // admin related 
    userRegister: {
        url: `${backendDomin}/api/register`,
        method: "post"
    },
    signIn: {
        url: `${backendDomin}/api/login`,
        method: "post"
    },

    // parties related Api
    addParty: {
        url: `${backendDomin}/api/addParty`,
        method: "POST"
    },
    getAllParties: {
        url: `${backendDomin}/api/getAllParties`,
        method: "GET"
    },
    getPartiesById: {
        url: (partyId) => `${backendDomin}/api/getPartyById/${partyId}`,
        method: "GET"
    },
    addPartyPayment: {
        url: `${backendDomin}/api/addPartyPayment`,
        method: "POST"
    },
    addBill: {
        url: `${backendDomin}/api/addBill`,
        method: "POST"
    },
    getPartyBillsById: {
        url: (partyId) => `${backendDomin}/api/getPartyBills/${partyId}`,
        method: "GET"
    },
    addPayment: {
        url: `${backendDomin}/api/addPayment`,
        method: 'POST'
    },
    getPaymentsByBillId: {
        url: (billId) => `${backendDomin}/api/getPaymentsByBillId/${billId}`,
        method: "GET"
    },

    cancelBill: {
        url: (billId) => `${backendDomin}/api/cancelBill/${billId}`,
        method: "POST"
    },
    updateBillStatus: {
        url: `${backendDomin}/api/updateBillStatus`,
        method: "PATCH"
    },

    // bank related routes 
    addBank: {
        url: `${backendDomin}/api/addBank`,
        method: "POST"
    },
    getAllBanks: {
        url: `${backendDomin}/api/getAllBanks`,
        method: "GET"
    },
    getBankDetails: {
        url: `${backendDomin}/api/getBankDetails`,
        method: "GET"
    },
    getBankDetailsById: {
        url: (id) => `${backendDomin}/api/getBankDetailsById/${id}`,
        method: "GET"
    },
    getBankTransaction: {
        url: `${backendDomin}/api/getBankTransaction`,
        method: "GET"
    },
    updateBank: {
        url: (id) => `${backendDomin}/api/updateBank/${id}`,
        method: "PUT"
    },

    //day book related route
    getDayBookTransactions: {
        url: (date) => `${backendDomin}/api/getDayBookTransactions?date=${date}`,
        method: "GET"
    },
    addDailyTransaction: {
        url: `${backendDomin}/api/addDailyTransaction`,
        method: "POST"
    },
    spendDailyTransaction: {
        url: `${backendDomin}/api/spendDailyTransaction`,
        method: "POST"
    },
    // staff related Api
    createStaff: {
        url: `${backendDomin}/api/addStaff`,
        method: "POST",
    },
    getAllStaff: {
        url: `${backendDomin}/api/getAllStaff`,
        method: "GET",
    },
    getStaffById: {
        url: (staffId) => `${backendDomin}/api/getStaffById/${staffId}`,
        method: "GET",
    },
    updateStaff: {
        url: (staffId) => `${backendDomin}/api/updateStaff/${staffId}`,
        method: "PUT",
    },
    deleteStaff: {
        url: (staffId) => `${backendDomin}/api/deleteStaff/${staffId}`,
        method: "DELETE",
    },
    updateSalaryStatus: {
        url: `${backendDomin}/api/staff/salary/update`,
        method: "POST"
    },
    //udhar related
    getAllUdhar: {
        url: `${backendDomin}/api/getAllUdhar`,
        method: "GET"
    },
    addUdharTransaction: {
        url: `${backendDomin}/api/addUdharTransaction`,
        method: "POST"
    },
    saveCashTally: {
        url: `${backendDomin}/api/saveCashTally`,
        method: "POST"
    },

    //parcel related Api
    addParcel: {
        url: `${backendDomin}/api/addParcel`,
        method: "POST"
    },

    getAllParcels: {
        url: `${backendDomin}/api/getAllParcel`,
        method: "GET"
    },
    updateParcel: {
        url: (id) => `${backendDomin}/api/updateParcel/${id}`,
        method: "PUT"
    },
    deleteParcel: {
        url: (id) => `${backendDomin}/api/deleteParcel/${id}`,
        method: "DELETE"
    },


    // Bhishi related Api
    createBhishiGroup: {
        url: `${backendDomin}/api/bhishi/create`,
        method: "POST"
    },
    getAllBhishiGroups: {
        url: `${backendDomin}/api/bhishi/all`,
        method: "GET"
    },
    getBhishiGroupDetails: {
        url: (id) => `${backendDomin}/api/bhishi/${id}`,
        method: "GET"
    },
    updateBhishiPayment: {
        url: `${backendDomin}/api/bhishi/payment`,
        method: "POST"
    },
    closeBhishiMonth: {
        url: `${backendDomin}/api/bhishi/close-month`,
        method: "POST"
    },
    restartBhishiGroup: {
        url: `${backendDomin}/api/bhishi/restart`,
        method: "POST"
    },
    addBhishiDetail: {
        url: `${backendDomin}/api/bhishi/add-detail`,
        method: "POST"
    },
    updateBhishiPayment: {
        url: `${backendDomin}/api/bhishi/update-payment`,
        method: "POST"
    },
    //attendance related Api
    markAttendance: {
        url: `${backendDomin}/api/attendance/mark`,
        method: "POST"
    },
    getStaffAttendance: {
        url: (id) => `${backendDomin}/api/attendance/${id}`,
        method: "GET"
    }
}

export default SummaryApi;